// extracted by mini-css-extract-plugin
export default {"container":"_404_container__bkhve","itemSection":"_404_itemSection__8qdkd","img404":"_404_img404__WhEfj"};